<template>
    <div class="flex flex-row gap-4 items-stretch">
        <UserCalendar
            v-if="userDetails?.has_calendar_integration"
            class="w-full grow"
            :initial-calendar-events="initialCalendarEvents"
            :calendar-coach-use-case="calendarCoachUseCase"
            :calendar-insights-enabled="calendarInsightsEnabled"
            @coach-hover="(...args) => $emit('coach-hover', ...args)"
            @coach-hover-end="(...args) => $emit('coach-hover-end', ...args)" />
        <CalendarEmptyState v-else class="w-full" />
    </div>
</template>

<script setup lang="ts">
import type { UserDetails } from "~vue/appTypes";
import CalendarEmptyState from "~vue/ChatHome/CalendarEmptyState.vue";
import UserCalendar from "~vue/ChatHome/UserCalendar.vue";
import type { CalendarIntegrationViewEvent } from "~vue/types/calendar_integration";
import type { ChatEntranceUseCaseData } from "~vue/types/chat";
import { inject, type Ref } from "vue";

interface Props {
    initialCalendarEvents: CalendarIntegrationViewEvent[] | null;
    calendarCoachUseCase: ChatEntranceUseCaseData | null;
    calendarInsightsEnabled: boolean;
}

withDefaults(defineProps<Props>(), {
    initialCalendarEvents: null,
    calendarCoachUseCase: null,
    calendarInsightsEnabled: false,
});

defineEmits(["coach-hover", "coach-hover-end"]);

const userDetails = inject<Ref<UserDetails>>("user_details");
</script>
